import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translator } from 'mage-i18n';
import { HorizontalWrapper } from 'moet-core';
import { ButtonSecondary, SpacerHorizontal, SpacerVertical, Typography } from '@klarna/bubble-ui';
import { CallToActionButton, ContainerTemplate } from '@/components';
import { getDecodedWidgetToken } from '@/utils/widget';
import ReviewSteps from './ReviewSteps';

type VerificationOverviewProps = {
  t: TranslatorFunction;
  onNext: () => void;
  onBack: () => void;
};

export const VerificationOverview = ({
  t,
  onNext,
  onBack,
}: VerificationOverviewProps): React.JSX.Element => {
  const tPrefix = 'products-fe.containers.merchant_verification_overview';
  const tPrefixGeneral = 'products-fe.containers.merchant_verification';
  const decodedWidgetToken = getDecodedWidgetToken();
  const date = new Date(decodedWidgetToken?.firstSeenAt).toLocaleDateString();

  return (
    <ContainerTemplate
      title={t('products-fe.containers.merchant_verification.title')}
      showRecaptchaFooter
    >
      <>
        <Typography textToken="text-style/text/super-paragraphs/body/regular">
          {t(`${tPrefix}.description.title`)}
        </Typography>
      </>
      <>
        <Typography textToken="text-style/text/super-paragraphs/body/regular">
          {`${t(`${tPrefix}.description.message_1`, { date })} `}
        </Typography>
        <Typography textToken="text-style/text/super-paragraphs/body/regular">
          {`${t(`${tPrefix}.description.message_2`)} `}
        </Typography>
      </>
      <ReviewSteps />
      <SpacerVertical spaceToken="space/100" />
      <HorizontalWrapper display="inline-flex" alignItems="center" justifyContent="flex-end">
        <ButtonSecondary onClick={onBack}>{t(`${tPrefixGeneral}.buttons.back`)}</ButtonSecondary>
        <SpacerHorizontal spaceToken="space/200" />
        <CallToActionButton onClick={onNext}>
          {t('products-fe.containers.merchant_verification.buttons.next')}
        </CallToActionButton>
      </HorizontalWrapper>
    </ContainerTemplate>
  );
};

VerificationOverview.propTypes = {
  t: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default connect(state => ({
  t: translator(state),
}))(VerificationOverview);
